type LocaleCode = "en" | "pt-br"

export type LocaleData = {
  code: LocaleCode
  native: string
  flagUrl: string
  htmlLang: string
}

export const allLocales: () => Record<LocaleCode, LocaleData> = () => ({
  en: {
    code: "en",
    native: "English",
    flagUrl: "/flags/us.webp",
    htmlLang: "en",
  },
  "pt-br": {
    code: "pt-br",
    native: "Português",
    flagUrl: "/flags/br.webp",
    htmlLang: "pt-BR",
  },
})

export const allLocalesKeys = () =>
  Object.keys(allLocales()) as Array<keyof ReturnType<typeof allLocales>>

export type SupportedLocaleCode = ReturnType<typeof allLocalesKeys>[number]

export const DEFAULT_LOCALE: SupportedLocaleCode = "en"

export const isSupportedLocale = (
  value: unknown,
): value is SupportedLocaleCode =>
  typeof value === "string" &&
  allLocalesKeys().includes(value as SupportedLocaleCode)
